export default "__VITE_ASSET__DuC$dM2k__"